(ns minorodata.components.forms.recipes-select
  (:require [reagent.core :as reagent]
            [re-posh.core :as re-posh]
            [clojure.string :as string]
            [minorodata.components.spinner.core :as components.spinner]
            [minorodata.app.handlers :refer [dispatch]]
            [ui.fields]))

(defn render-select-options [options]
  (mapv (fn [{:keys [value name]}]
          {:value value :text name :data-cy (str "recipe-select-option-" value)})
        options))


(defn source-select [{:keys [block fields errors data-cy]}]
  (let [{:keys [label loading-text disabled-text name type required
                upstream-deps downstream-deps empty-option-text
                source-type
                options-sub loading-sub]
         :or   {empty-option-text "No data"
                label             "Select source"
                loading-sub       [:mold-http/loading? :connections.api/fetch-sources]
                options-sub       :recipes.subs/source-options
                loading-text      "Loading sources..."}} block

        options      (re-posh/subscribe [options-sub source-type])
        loading?     (re-posh/subscribe loading-sub)
        req-loading? (re-posh/subscribe loading-sub)

        make-options (fn []
                       (mapv (fn [{:source/keys [source-id name]}]
                               {:name name :value source-id})
                             (or @options [])))

        dependencies      (map fields upstream-deps)
        dependency-values (map :value dependencies)

        disabled?  (if (empty? dependencies)
                     false
                     (some clojure.string/blank? dependency-values))

        field (get fields name)

        rendered-options (fn [] (render-select-options (make-options)))

        on-change (fn [evt]
                    ;; drop downstream deps
                    (doall
                     (for [dep downstream-deps
                           :let [action (get-in fields [dep :action])]]
                       (action nil)))

                    ((:action field) evt))]

    (reagent/create-class
     {:display-name
      "recipe-source-select"

      :render
      (fn []
        (let [disabled-or-loading? (or @req-loading? disabled?)
              empty-options?       (empty? @options)]

          (if (and disabled-or-loading? (:inline-loader block))
            [:div {:style {:height "48px" :margin-top "16px" :margin-bottom "8px" :display "flex" :align-items "flex-end"}}
             [:span {:style {:margin-right "10px"}}
              [components.spinner/inline-configurable {:color "primary" :size 16}]]
             loading-text]

            ^{:key (str @options disabled? @loading? @req-loading? empty-options? (:value field))}
            [ui.fields/select
             {:field         (assoc field :action on-change)
              :data-cy       data-cy
              :errors        errors
              :key           (str @options (:value field) disabled? @loading? empty-options?)
              :id            name
              :variant       "standard"
              :type          type
              :required      required
              :native        false
              :options       (rendered-options)
              :disabled      (or disabled-or-loading? empty-options?)
              :label         (cond
                              @req-loading?  loading-text
                              empty-options? empty-option-text
                              disabled?      disabled-text
                              :else          label)}])))})))



(defn extract-select [{:keys [block fields errors data-cy]}]
  (let [{:keys [label loading-text disabled-text name type required
                upstream-deps downstream-deps empty-option-text

                source-id
                options-sub loading-sub]
         :or   {empty-option-text "No data"
                label             "Select extract"
                loading-sub       [:mold-http/loading? :connections.api/fetch-extracts]
                options-sub       :recipes.subs/extract-options
                loading-text      "Loading extracts..."}} block

        options      (re-posh/subscribe [options-sub (get-in fields source-id)])
        loading?     (re-posh/subscribe loading-sub)
        req-loading? (re-posh/subscribe loading-sub)

        make-options (fn []
                       (mapv (fn [{:extract/keys [extract-id name]}]
                               {:name name :value extract-id})
                             (or @options [])))

        dependencies      (map fields upstream-deps)
        dependency-values (map :value dependencies)

        disabled?  (if (empty? dependencies)
                     false
                     (some clojure.string/blank? dependency-values))

        field (get fields name)

        rendered-options (fn [] (render-select-options (make-options)))

        on-change (fn [evt]
                    ;; drop downstream deps
                    (doall
                     (for [dep downstream-deps
                           :let [action (get-in fields [dep :action])]]
                       (action nil)))

                    ((:action field) evt))]

    (reagent/create-class
     {:display-name
      "recipe-extract-select"

      :component-did-mount
      (fn []
        (when (and (some? (get-in fields source-id))
                   (not (clojure.string/blank? (get-in fields source-id))))
          (dispatch [:connections.api/fetch-extracts {:source-id (get-in fields source-id)}])))

      :render
      (fn []
        (let [disabled-or-loading? (or @req-loading? disabled?)
              empty-options?       (empty? @options)]

          (if (and disabled-or-loading? (:inline-loader block))
            [:div {:style {:height "48px" :margin-top "16px" :margin-bottom "8px" :display "flex" :align-items "flex-end"}}
             [:span {:style {:margin-right "10px"}}
              [components.spinner/inline-configurable {:color "primary" :size 16}]]
             loading-text]

            ^{:key (str @options disabled? @loading? @req-loading? empty-options? (:value field))}
            [ui.fields/select
             {:field         (assoc field :action on-change)
              :data-cy       data-cy
              :errors        errors
              :key           (str @options (:value field) disabled? @loading? empty-options?)
              :id            name
              :variant       "standard"
              :type          type
              :required      required
              :native        false
              :options       (rendered-options)
              :disabled      (or disabled-or-loading? empty-options?)
              :label         (cond
                              @req-loading?  loading-text
                              empty-options? empty-option-text
                              disabled?      disabled-text
                              :else          label)}])))})))


(defn group-select [{:keys [block fields errors data-cy]}]
  (let [{:keys [label loading-text disabled-text name type required
                upstream-deps downstream-deps empty-option-text
                options-sub loading-sub]
         :or   {empty-option-text "No data"
                label             "Select group"
                loading-sub       [:mold-http/loading? :group.api/fetch-groups]
                options-sub       :recipes.subs/group-options
                loading-text      "Loading groups..."}} block

        options      (re-posh/subscribe [options-sub])
        loading?     (re-posh/subscribe loading-sub)
        req-loading? (re-posh/subscribe loading-sub)

        make-options (fn []
                       (mapv (fn [{:group/keys [id name]}] {:name name :value id})
                             (or @options [])))

        dependencies      (map fields upstream-deps)
        dependency-values (map :value dependencies)

        disabled?  (if (empty? dependencies)
                     false
                     (some clojure.string/blank? dependency-values))

        field (get fields name)

        rendered-options (fn [] (render-select-options (make-options)))

        on-change (fn [evt]
                    ;; drop downstream deps
                    (doall
                     (for [dep downstream-deps
                           :let [action (get-in fields [dep :action])]]
                       (action nil)))

                    ((:action field) evt))]

    (reagent/create-class
     {:display-name
      "recipe-group-select"

      :render
      (fn []
        (let [disabled-or-loading? (or @req-loading? disabled?)
              empty-options?       (empty? @options)]

          (if (and disabled-or-loading? (:inline-loader block))
            [:div {:style {:height "48px" :margin-top "16px" :margin-bottom "8px" :display "flex" :align-items "flex-end"}}
             [:span {:style {:margin-right "10px"}}
              [components.spinner/inline-configurable {:color "primary" :size 16}]]
             loading-text]

            ^{:key (str @options disabled? @loading? @req-loading? empty-options? (:value field))}
            [ui.fields/select
             {:field         (assoc field :action on-change)
              :data-cy       data-cy
              :errors        errors
              :key           (str @options (:value field) disabled? @loading? empty-options?)
              :id            name
              :variant       "standard"
              :type          type
              :required      required
              :native        false
              :options       (rendered-options)
              :disabled      (or disabled-or-loading? empty-options?)
              :label         (cond
                              @req-loading?  loading-text
                              empty-options? empty-option-text
                              disabled?      disabled-text
                              :else          label)}])))})))
